import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {EmailEditorComponent} from 'angular-email-editor';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DesignEmailTemplate} from '../../../model/DesignEmailTemplate';
import {TranslateService} from '@ngx-translate/core';
import {DesignEmailTemplateService} from '../../../service/design-email-template.service';
import {Workflow} from '../../../model/Workflow';
import {Dialog} from '../../../../global/util/Dialog';
import {InformType} from '../../../../global/util/enum/InformType';
import {MailtemplateType} from '../../../../global/util/MailtemplateType';

@Component({
  selector: 'app-design-email-template',
  templateUrl: './design-email-template.component.html',
  styleUrls: ['./design-email-template.component.css']
})
export class DesignEmailTemplateComponent implements OnInit, AfterViewInit {
  @ViewChild(EmailEditorComponent)
  private emailEditor: EmailEditorComponent;
  loading: boolean;
  workflow: Workflow;
  emailTemplate: DesignEmailTemplate;
  designEmailTemplateForm: FormGroup;
  body = '';
  alertType: number;
  entityName = '';

  // called when the editor is created
  constructor(private activeModal: NgbActiveModal,
              private builder: FormBuilder,
              public translate: TranslateService,
              private designService: DesignEmailTemplateService) {
    this.createForm();
  }

  ngOnInit(): void {
    this.entityName = this.alertType === MailtemplateType.SEND_DOCUMENT_ATTACHTMENT ? 'TITLE.CONTENT' : 'TITLE.DESIGN-EMAIL-BODY-TEMPLATE';
    this.initialLoading();
    this.loadDesignEmailTemplate();
  }

  // Leer la data en formato Json, valor por defecto {}
  editorLoaded() {
    setTimeout(() => {
      if (this.emailTemplate.jsonContent.length !== undefined) {
        this.emailEditor.editor.loadDesign(JSON.parse(this.emailTemplate.jsonContent));
      }
    }, 1500);
  }

  // called when the editor has finished loading
  editorReady() {
    console.log('editorReady');
  }


  save() {
    this.loading = true;
    this.setBodyHtml();
    this.emailEditor.editor.saveDesign((data: any) => {
      if (this.isPresentParameters(this.body)) {
        this.setInitialData(data);
        this.designService.register(this.emailTemplate).subscribe(value => {
          this.loading = false;
          this.activeModal.close(InformType.Success);
        }, error => {
          this.loading = false;
          this.activeModal.close(InformType.Danger);
        });
      } else {
        this.loading = false;
        Dialog.show(InformType.Warning, 'Agregue parámetros', 'Es importante agregar al menos un parámetro para que la plantilla del cuerpo de correo se registre');
        // this.activeModal.close(InformType.Success);
      }
    });
  }

  close() {
    this.activeModal.close();
  }

  private initialLoading() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 3500);
  }

  private createForm() {
    this.designEmailTemplateForm = this.builder.group({
      subject: [''],
      subject1: [''],
      body: ['', Validators.required]
    });
  }

  private setInitialData(data: any) {
    this.emailTemplate = new DesignEmailTemplate();
    this.emailTemplate.workflowId = this.workflow.id;
    this.emailTemplate.mailTemplateType = this.alertType;
    this.emailTemplate.body = this.body;
    this.emailTemplate.subject = this.designEmailTemplateForm.get('subject').value;
    this.emailTemplate.jsonContent = JSON.stringify(data);
  }

  ngAfterViewInit(): void {
  }

  private loadDesignEmailTemplate() {
    this.designService.getBy(this.workflow.id, this.alertType).subscribe((template: any) => {
      if (template !== null) {
        this.emailTemplate = template;
      } else {
        this.emailTemplate = new DesignEmailTemplate();
        this.emailTemplate.jsonContent = JSON.parse('{}');
      }
    });
  }

  private setBodyHtml() {
    this.emailEditor.editor.exportHtml((data: any) => {
      if (data !== null) {
        this.body = data.html;
      }
    });
  }

  private isPresentParameters(body: string) {
    return this.body.includes('${subjectDocument}') ||
      this.body.includes('${documentNumber}') ||
      this.body.includes('${fullName}') ||
      this.body.includes('${enterpriseName}') ||
      this.body.includes('${urlSignature}') ||
      this.body.includes('${date}') ||
      this.body.includes('${datetime}');
  }

  viewParams() {
    let message = this.translate.instant('MESSAGE.PARAMETERS-ALLOWED-IN-DESIGN-EMAIL-TEMPLATE').concat('<ul>');
    message = message.concat('<li><b>${subjectDocument} </b>', this.translate.instant('MESSAGE.SUBJECT-DOCUMENT'), ': Documento K0239</li>');
    if (this.alertType !== MailtemplateType.SEND_DOCUMENT_ATTACHTMENT) {
      message = message.concat('<li><b>${documentNumber} </b>', this.translate.instant('MESSAGE.DOCUMENT-NUMBER-RESULT'), ': 00000000</li>');
      message = message.concat('<li><b>${fullName} </b>', this.translate.instant('MESSAGE.NAMES-RESULT'), ': JOSE PINTO PAGAZA</li>');
    }
    message = message.concat('<li><b>${enterpriseName} </b>', this.translate.instant('MESSAGE.ENTERPRISE-NAME-RESULT'), ': Empresa abd S.A.C.</li>');
    message = message.concat('<li><b>${urlSignature} </b>', this.translate.instant('MESSAGE.URL-RESULT'), ': https://iofesign.com/xxxxxxxxx/0000 </li>');
    message = message.concat('<li><b>${date} </b>', this.translate.instant('MESSAGE.DATE-RESULT'), ': 15/12/2021</li>');
    message = message.concat('<li><b>${datetime} </b>', this.translate.instant('MESSAGE.DATE-AND-TIME-RESULT'), ': 15/12/2021 14:28:31</li>');
    message = message.concat('</ul>');
    Dialog.show(InformType.Info, this.translate.instant('TITLE.PARAMETERS-IN-EMAIL-DESIGN-TEMPLATE'), message);
  }
}
